import { CancelTokenSource } from 'axios'
import AnonymousAgent from '../api/AnonymousAgent'
import { Feedback } from '../models/Feedback'

class FeedbackService {
  getLookupData(source?: CancelTokenSource) {
    return AnonymousAgent.RefData.getLookupData(source)
  }

  createFeedback = async (request: Feedback, source?: CancelTokenSource) => {
    return AnonymousAgent.Feedbacks.create(request, source)
  }
}

export default new FeedbackService()
